import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/globals.css'
import './styles/fut-card.css'
import './styles/match-rating.css'
import ErrorBoundary from './components/ErrorBoundary'
import * as Sentry from "@sentry/react";
import { inject } from "@vercel/analytics";

// Initialize Vercel Analytics
inject();

// Register Service Worker for Push Notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => console.log('Service Worker registrado con éxito:', reg.scope))
      .catch(err => console.error('Error al registrar Service Worker:', err));
  });
}

// Initialize Sentry
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://759f3846bad31ec59c3b266381a8c0b7@o4511249434411008.ingest.us.sentry.io/4511249441882112",
    sendDefaultPii: true, // Recolecta IP y datos básicos para debugging
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", "lmmfskzzqknyejwdntmp.supabase.co"], 
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Enable metrics and logs
    enableLogs: true,
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
